import React from 'react'

import { IconButton, Snackbar, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import { Box } from '@mui/system'

import successImg from 'assets/images/toast/success.svg'
import failedImg from 'assets/images/toast/failed.svg'

import successIcon from 'assets/images/toast/successIcon.svg'
import failedIcon from 'assets/images/toast/failedIcon.svg'

export const Toast = ({ open, handleClose, type, title, message }) => {

    const Content = () => {

        if (!title) return null

        return <Box sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box sx={{ borderRight: '2px dashed #F3F3F3', p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src={type == 'success' ? successImg : failedImg} />
                </Box>

                <Box sx={{ display: "flex", flexDirection: 'column', px: 1 }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <img src={type == 'success' ? successIcon : failedIcon} />
                        <Typography fontSize={16} sx={{ mx: 0.75 }} fontWeight={700} >{title}</Typography>
                    </Box>

                    <Typography color='#99B1D1' fontSize={14}>{message}</Typography>

                </Box>
            </Box>
            
            <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <IconButton sx={{ background: '#F8F8FD' }} onClick={handleClose}><Close /></IconButton>
            </Box>


        </Box>
    }

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
            action={<Content />}
            sx={{
                '& .MuiSnackbarContent-root': {
                    borderRadius: '5px',
                    background: "#fff",
                    color: 'CaptionText',
                    minWidth: { sm: '450px' },
                    position: 'relative',
                    p: 0,
                    '&:before': {
                        backgroundColor: type == 'success' ? 'primary.main' : '#F95D5D',
                        borderBottomLeftRadius: '5px',
                        borderBottomRightRadius: '5px',
                        bottom: "0px",
                        color: type == 'success' ? 'primary.main' : '#F95D5D',
                        content: '"-"',
                        height: '4px',
                        position: 'absolute',
                        right: '0',
                        fontSize: '0.1rem',
                        overflow: 'hidden',
                        width: "100%",
                    }
                },
                '& .MuiSnackbarContent-action': { margin: 0, padding: 0, width: '100%' },
            }}
        >
        </Snackbar>
    )
}
